import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { getNominationRoundYear } from '../../../utils/getNominationRoundYear';

const ExportAllocationsButton = ({
  groupedData,
  allocations,
  rankedNominations,
}) => {
  const getRanking = (nominationId) => {
    const nom = rankedNominations.find((n) => n.id === nominationId);
    return nom?.ranking ?? '';
  };

  const exportToCSV = () => {
    if (!groupedData.length) return;

    const rows = [];

    groupedData.forEach((committee, index) => {
      if (index > 0) {
        rows.push([]);
        rows.push([]);
        rows.push([]);
      }

      rows.push([committee.committeeName]);

      const headers = ['Candidate Name', 'Ranking', 'Allocated Council Member'];
      rows.push(headers);

      const sortedNominations = [...committee.nominations].sort(
        (a, b) =>
          (getRanking(a.nominationId) || Infinity) -
          (getRanking(b.nominationId) || Infinity),
      );

      sortedNominations.forEach((nomination) => {
        const allocation = allocations[nomination.nominationId];
        const councilMemberName = allocation?.label || '';

        rows.push([
          nomination.candidateName,
          getRanking(nomination.nominationId),
          councilMemberName,
        ]);
      });
    });

    const csvContent = rows
      .map((row) =>
        row
          .map((cell) => {
            const cellStr = String(cell ?? '');
            const safeCell = /^[=\-+@]/.test(cellStr) ? `'${cellStr}` : cellStr;
            const escapedCell = safeCell.replace(/"/g, '""');
            return `"${escapedCell}"`;
          })
          .join(','),
      )
      .join('\n');

    const BOM = '\uFEFF';
    const csvWithBOM = BOM + csvContent;

    const blob = new Blob([csvWithBOM], {
      type: 'text/csv;charset=utf-8',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Council_Member_Allocations_${getNominationRoundYear(new Date())}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="d-flex justify-content-center mt-xl-5 mb-4">
      <Button
        variant="primary"
        onClick={exportToCSV}
        disabled={!groupedData.length}
        className="standard-width-button d-flex align-items-center gap-2"
      >
        <i className="fas fa-file-export" />
        Export All Allocations
      </Button>
    </div>
  );
};

ExportAllocationsButton.propTypes = {
  groupedData: PropTypes.arrayOf(
    PropTypes.shape({
      committeeId: PropTypes.number.isRequired,
      committeeName: PropTypes.string.isRequired,
      nominations: PropTypes.arrayOf(
        PropTypes.shape({
          nominationId: PropTypes.number.isRequired,
          candidateName: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  allocations: PropTypes.object.isRequired,
  rankedNominations: PropTypes.array.isRequired,
};

export default ExportAllocationsButton;
